module.exports = __webpack_public_path__ + "img/electric-mining-drill-W.536503bf.png";